<template>
  <base-container ref="container" :isLoading="loading" style="overflow: hidden">
    <base-container style="height: 100%">
      <el-descriptions
        :column="1"
        border
        size="small"
        :labelStyle="{ width: '100px', textAlign: 'center' }"
      >
        <el-descriptions-item label="排班日期">
          <el-date-picker
            size="mini"
            style="width: 100%"
            type="dates"
            v-model="data.scheduleDates"
            value-format="yyyy-MM-dd"
            placeholder="选择一个或多个日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
      <artisan-group title="排班规则">
        <template #header>
          <el-row type="flex" justify="space-between" align="middle">
            <span>排班信息</span>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-setting"
              :disabled="!data.scheduleDates.length"
              @click="isShow = true"
            >
              设置时段排班
            </el-button>
          </el-row>
        </template>
        <el-table
          v-if="data.scheduleDates.length"
          border
          stripe
          :data="schedules"
          :header-cell-style="getCellStyle"
          size="mini"
          highlight-current-row
        >
          <el-table-column
            align="center"
            header-align="center"
            prop="scheduleDate"
            label="日期"
            width="120"
          ></el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="schedules"
            label="日期排班信息"
          >
            <template slot-scope="{ row }">
              <div class="week-container">
                <el-row>
                  <el-col
                    v-for="(period, index) in row.schedules"
                    :key="index"
                    @click.native="editRule(period)"
                    :span="6"
                  >
                    <div class="schedule-item">
                      <span>
                        <b>{{ period.startPoint }}</b>
                        -{{ period.endPoint }}
                      </span>
                      <span class="margin-h5">
                        {{ period.totalCount }}
                        <i
                          @click.prevent.stop="delSchedule(period)"
                          class="el-icon-delete color-danger"
                        ></i>
                      </span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="schedule-item">
                      <b>合计</b>
                      <b>{{ summary(row.schedules) }}</b>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="scheduleDate"
            label="日期"
            width="120"
          >
            <template slot-scope="{ row }">
              <el-button
                class="margin-v3"
                size="mini"
                type="success"
                icon="el-icon-plus"
                @click="addRule(row.scheduleDate)"
              >
                新增
              </el-button>
              <br />
              <el-button
                class="margin-v3"
                v-show="row.schedules.length"
                size="mini"
                type="primary"
                icon="el-icon-setting"
                @click="setRule(row.scheduleDate)"
              >
                设置
              </el-button>
              <br />
              <el-button
                class="margin-v3"
                v-show="row.schedules.length"
                size="mini"
                type="danger"
                icon="el-icon-remove-outline"
                @click="clearRule(row.scheduleDate)"
              >
                清除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-else description="请先选择临时排班的日期"></el-empty>
      </artisan-group>
    </base-container>
    <artisan-dialog
      ref="drawer"
      title="排班规则设置"
      :visible.sync="isShow"
      height="90%"
      width="90%"
    >
      <WeekPeriodRuleSetting
        :show-week="false"
        ref="ruleForm"
        v-if="isShow"
      ></WeekPeriodRuleSetting>
      <template #footer>
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-close"
          @click="isShow = false"
        >
          取消
        </el-button>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="buildRules"
          >确认</el-button
        >
      </template>
    </artisan-dialog>
    <artisan-dialog
      ref="batchDialog"
      :title="batchDialog.title"
      :visible.sync="batchDialog.show"
      height="90%"
      width="90%"
    >
      <el-table
        border
        stripe
        :data="batchDialog.schedules"
        size="mini"
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          header-align="center"
          type="selection"
          width="40"
        >
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="scheduleDate"
          label="日期"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="period"
          label="时段"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ row.startPoint }}-{{ row.endPoint }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="totalCount"
          label="时段号源数"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="row.totalCount"
              @change="totalCountChange"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="totalCount"
          label="预留号源数"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="row.saveCount"
              @change="saveCountChange"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="signTime"
          label="签到时间"
          width="270"
        >
          <template slot-scope="{ row }">
            <el-time-select
              size="mini"
              style="width: 100px"
              placeholder="起始时间"
              v-model="row.signStart"
              @change="signStartChange"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
            >
            </el-time-select>
            <span class="margin-h10">-</span>
            <el-time-select
              size="mini"
              style="width: 100px"
              placeholder="结束时间"
              v-model="row.signEnd"
              @change="signEndChange"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: row.signStart,
              }"
            >
            </el-time-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="clinicType"
          label="就诊类型"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-select
              size="mini"
              v-model="row.clinicType"
              @change="clinicTypeChange"
            >
              <el-option label="不限" value=""></el-option>
              <el-option label="门诊" value="outpatient"></el-option>
              <el-option label="住院" value="inpatient"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="appIds"
          label="授权渠道"
        >
          <template slot-scope="{ row }">
            <el-select
              style="width: 100%"
              multiple
              collapse-tags
              size="mini"
              v-model="row.appIds"
              @change="appChange"
            >
              <el-option
                :label="app.label"
                v-for="app in appList"
                :key="app.value"
                :value="app.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="batchDialog.show = false"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
    <artisan-dialog
      ref="editDialog"
      :title="editDialog.title"
      :visible.sync="editDialog.show"
      height="75%"
      width="70%"
    >
      <ScheduleForm
        ref="scheduleForm"
        v-if="editDialog.show"
        :data="editDialog.schedule"
      ></ScheduleForm>
      <template #footer>
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-close"
          @click="editDialog.show = false"
        >
          取消
        </el-button>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-check"
          @click="confirmEdit"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getBelongTypeLabel, getWeekLabel } from "@/util/util";
import ScheduleForm from "./ScheduleForm.vue";
import WeekPeriodRuleSetting from "./WeekPeriodRuleSetting.vue";
import { loadEnum } from "@/api/sys/dicType";
export default {
  components: {
    WeekPeriodRuleSetting,
    ScheduleForm,
  },
  props: {
    resId: [String, Number],
  },
  data() {
    return {
      loading: false,
      isShow: false,
      editDialog: {
        show: false,
        isEdit: false,
        title: "",
        schedule: {},
      },
      batchDialog: {
        show: false,
        title: "",
        schedules: [],
      },
      data: {
        resId: this.resId,
        scheduleDates: [],
        schedules: [],
      },
      appList: [],
      selectRows: [],
      pickerOptions: {
        disabledDate(time) {
          let day = new Date();
          day.setHours(0, 0, 0, 0);
          return time.getTime() < day.getTime();
        },
      },
    };
  },
  computed: {
    schedules() {
      let scheduleMap = {};
      this.data.schedules.forEach((c) => {
        if (scheduleMap[c.scheduleDate]) {
          scheduleMap[c.scheduleDate].push(c);
        } else {
          scheduleMap[c.scheduleDate] = [c];
        }
      });
      let data = this.data.scheduleDates.map((r) => {
        return {
          scheduleDate: r,
          schedules: scheduleMap[r] || [],
        };
      });
      return data;
    },
  },
  created() {
    loadEnum("SysAppInfo").then((res) => {
      this.appList = res.data.data;
    });
  },
  methods: {
    getBelongTypeLabel,
    getWeekLabel,
    getCellStyle() {
      let obj = { color: "white" };
      obj.backgroundColor = "#409EFF";
      return obj;
    },
    summary(periods) {
      let sum = 0;
      periods.forEach((c) => {
        sum += c.totalCount;
      });
      return sum;
    },
    handleSelectionChange(val) {
      this.selectRows = val;
    },
    signStartChange(val) {
      this.selectRows.forEach((c) => (c.signStart = val));
    },
    signEndChange(val) {
      this.selectRows.forEach((c) => (c.signEnd = val));
    },
    clinicTypeChange(val) {
      this.selectRows.forEach((c) => (c.clinicType = val));
    },
    totalCountChange(val) {
      this.selectRows.forEach((c) => (c.totalCount = val));
    },
    saveCountChange(val) {
      this.selectRows.forEach((c) => (c.saveCount = val));
    },
    appChange(val) {
      this.selectRows.forEach((c) => {
        c.appIds.splice(0, c.appIds.length, ...val);
      });
    },
    clearRule(scheduleDate) {
      this.$refs.container.confirm({ msg: "确定清除排班?" }).then(() => {
        this.data.schedules = this.data.schedules.filter(
          (c) => c.scheduleDate != scheduleDate
        );
      });
    },
    buildRules() {
      let ruleData = this.$refs.ruleForm.getRules();
      if (ruleData.periods.length) {
        let rules = [];
        this.data.scheduleDates.forEach((d) => {
          ruleData.periods.forEach((p) => {
            rules.push({
              scheduleDate: d,
              startPoint: p.startPoint,
              endPoint: p.endPoint,
              clinicType: p.clinicType,
              totalCount: p.numCount,
              signStart: p.signStart,
              signEnd: p.signEnd,
              saveCount: p.saveCount,
              appIds: p.appIds,
            });
          });
        });
        let schedules = this.data.schedules.filter(
          (c) =>
            !(
              ruleData.startTime <= c.startPoint &&
              ruleData.endTime >= c.endPoint
            )
        );
        schedules = schedules.concat(rules);
        schedules.sort((a, b) => (a.startPoint >= b.startPoint ? 1 : -1));
        this.data.schedules = schedules;
        this.isShow = false;
      } else {
        this.$message({
          type: "error",
          message: "请设置排班！",
        });
      }
    },
    editRule(data) {
      this.editDialog.schedule = data;
      this.isEdit = true;
      this.editDialog.title = `${data.scheduleDate} ${data.startPoint}-${data.endPoint}`;
      this.editDialog.show = true;
    },
    setRule(scheduleDate) {
      this.batchDialog.schedules = this.data.schedules.filter(
        (c) => c.scheduleDate == scheduleDate
      );
      this.batchDialog.title = `${scheduleDate}--批量设置`;
      this.batchDialog.show = true;
    },
    addRule(scheduleDate) {
      this.editDialog.schedule = {
        scheduleDate,
        startPoint: "",
        endPoint: "",
        clinicType: "",
        totalCount: 0,
        saveCount: 0,
        signStart: "00:00",
        signEnd: "24:00",
        ruleIds: [],
        appIds: [],
      };
      this.isEdit = false;
      this.editDialog.title = `${scheduleDate}--新增`;
      this.editDialog.show = true;
    },
    delSchedule(period) {
      let index = this.data.schedules.findIndex(
        (c) =>
          c.scheduleDate == period.scheduleDate &&
          c.startPoint == period.startPoint
      );
      this.data.schedules.splice(index, 1);
    },
    confirmEdit() {
      let data = this.$refs.scheduleForm.getData();
      if (this.editDialog.isEdit) {
        Object.assign(this.editDialog.schedule, data);
      } else {
        this.data.schedules.push(data);
        console.log(this.data);
      }
      this.editDialog.show = false;
    },
    getData() {
      return this.data;
    },
  },
};
</script>

<style lang="scss" scoped>
i.el-icon-question:hover {
  color: #1989fa;
  cursor: pointer;
}
table.el-table__body {
  tbody {
    td.el-table__cell:hover {
      div.op-menu {
        display: inline-block;
      }
      div.cell {
        padding: 0 5px;
      }
    }
  }
}
.op-menu {
  position: absolute;
  display: none;
  z-index: 500;
  bottom: 0;
  right: 0;
  padding: 5px;
  background-color: #aaacaf;
  .menu-item {
    padding: 5px 10px;
    text-align: center;
    cursor: pointer;
    color: white;
    background-color: black;
    opacity: 0.3;
  }
  .menu-item:hover {
    background-color: #409eff;
    opacity: 1;
  }
}
.schedule-item {
  margin: 0 10px;
  border-bottom: 0.5px #409eff solid;
  cursor: pointer;
  padding: 5px 0 2px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background-color: #409eff;
    color: white;
  }
}
</style>
